import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { catchError, filter, first, map, Observable, of, timeout } from 'rxjs';
import { ShopService } from '@app/services/shops/shop.service';

const EXTENSIONS_LIST_URL = '/convert/extensions';

/**
 * Keeps the Multi-shipment extension route reachable only for shops whose metadata opts in.
 * Waits for the shop to load (so a refresh/deep-link doesn't redirect before metadata arrives),
 * then sends the user back to the extensions list when the flag is off.
 */
@Injectable({
  providedIn: 'root',
})
export class MultiShipmentEnabledGuard {
  constructor(
    private shopService: ShopService,
    private router: Router,
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.shopService.shop$.pipe(
      filter((shop) => !!shop),
      first(),
      timeout(5000),
      map((shop) => (shop.metadata?.showMultiShipmentExtension ? true : this.router.parseUrl(EXTENSIONS_LIST_URL))),
      catchError(() => of(this.router.parseUrl(EXTENSIONS_LIST_URL))),
    );
  }
}
